<div class="identi-page-wrapper pb-5">
  <app-product-hero
    [level]="productLevels.Level1"
    title="identibase+"
    subtitle="Stay connected & contactable <br><br> Keeping your details connected to your pet is crucial to reuniting you"
    (onBuyClick)="buyIdentibasePlusSubscription()"
    (onCompareClick)="compareClick()"
    [compareVisible]="buyButtonVisible"
    [levelsVisible]="true"
    [buyHidden]="!buyButtonVisible"
    [disabled]="!hasIdentibasePlusOption && isAuthenticated"
    badgeUri="/assets/images/identibase/identibasePlus/hero-badge-5.svg"
  ></app-product-hero>

  <div class="row py-4 light-background">
    <div class="col-12 text-center px-3">
      <div class="row row-cols-lg-5 row-cols-md-5 row-cols-2 mt-1 px-lg-5 px-md-3 px-sm-1 d-flex justify-content-center">
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/identibasePlus/puzzle-icon.svg"
            alt="puzzle-icon"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            Link your details to your pet’s microchip
          </h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/identiAlert/alert-badge.svg"
            alt="alert-badge"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            Instant notification <br> when your missing <br>pet’s chip is scanned
          </h6>
        </div>
        <div class="col text-center my-2">
          <img
          class="feature-icon"
          src="/assets/images/identibase/identibasePlus/helpline.svg"
          alt="helpline"
        />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            24/7 access to our <br> missing pet helpline
          </h6>
        </div>
        <div class="col text-center my-2">
          <img
            class="feature-icon"
            src="/assets/images/identibase/identibasePlus/one-plan.svg"
            alt="one-plan"
          />
          <h6 class="mt-lg-3 mt-md-3 mt-sm-2">
            <p class="mb-0"><b>One plan covers all</b></p>
            identibase chipped pets
          </h6>
        </div>
      </div>
      <button
        *ngIf="buyButtonVisible"
        (click)="buyIdentibasePlusSubscription()"
        type="button"
        class="btn blue-button mt-lg-4 mt-md-3 mt-sm-2"
        [disabled]="!hasIdentibasePlusOption && isAuthenticated"
      >
        Buy now
      </button>
    </div>
  </div>

  <div class="row pt-5 mid-background" *ngIf="buyButtonVisible">
    <div class="col-12 text-center position-relative">
      <h3 class="mb-3">When your pet goes missing, you panic. Every minute matters.</h3>
      <a *ngIf="hasIdentiAlertOption" [routerLink]="[]" (click)="buyIdentiAlertSubscription()"
        >Upgrade to identialert</a
      >
      <a *ngIf="!hasIdentiAlertOption && isAuthenticated" routerLink="/identialert">Upgrade to identialert</a>
      <h5 class="mt-3 mb-5">
        The most effective way to find your <br> missing pet for just £36 a year.
      </h5>
    </div>
  </div>

  <span *ngIf="desktopViewVisible; else mobileSubscriptionTable">
    <app-subscription-table-desktop
      id="subscription-table"
      [identibasePlusButtonLabel]="'Buy now'"
      [identialertButtonLabel]="'Learn more'"
      [identifindButtonLabel]="'Learn more'"
      [basicPlusHighlighted]="true"
      [buyButtonVisible]="buyButtonVisible"
      [buyButtonDisabled]="!hasIdentibasePlusOption && isAuthenticated"
      (identitableButtonClicked)="onIdentitableButtonClicked($event)"
    ></app-subscription-table-desktop>
  </span>
  <ng-template #mobileSubscriptionTable>
    <app-subscription-table-mobile
      id="subscription-table"
      [identibasePlusButtonLabel]="'Buy now'"
      [identialertButtonLabel]="'Learn more'"
      [identifindButtonLabel]="'Learn more'"
      [basicPlusHighlighted]="true"
      [buyButtonVisible]="buyButtonVisible"
      [buyButtonDisabled]="!hasIdentibasePlusOption && isAuthenticated"
      (identitableButtonClicked)="onIdentitableButtonClicked($event)"
    ></app-subscription-table-mobile>
  </ng-template>
</div>
